An array of phone numbers for the person.

The phone numbers are ordered in descending preference.

Between 0 and 5 phone numbers may be provided, inclusive.
